import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import ForIos from '../views/forIos.vue'
import ForPc from '../views/forPc.vue'
import site from '@/config/site.json'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const canonical = (path) => `${site.domain}${path}`

export const constRoutesPc = [
  {
    path: '/',
    name: 'en-home',
    meta: {
      appname: site.appName,
      title: site.homeTitle,
      keywords: site.homeKeywords,
      description: site.homeDescription,
      link: [
        {
          rel: 'canonical',
          href: canonical('/'),
        },
      ],
    },
    component: Home,
  },
  {
    path: '/download-apk/',
    name: 'en-download',
    meta: {
      appname: site.appName,
      title: site.downloadTitle,
      keywords: site.downloadKeywords,
      description: site.downloadDescription,
      link: [
        {
          rel: 'canonical',
          href: canonical(site.downloadPath),
        },
      ],
    },
    component: () => import('@/views/download.vue'),
  },
  {
    path: '/for-ios/',
    name: 'en-for-ios',
    meta: {
      appname: site.appName,
      title: 'GB WhatsApp for iOS: Is It Available on iPhone?',
      keywords: 'GB WhatsApp for iOS, GB WhatsApp iPhone, GB WhatsApp IPA',
      description: 'Looking for GB WhatsApp for iOS? Find out whether GB WhatsApp works on iPhone, what GB WhatsApp IPA means, and what iPhone users can actually use.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/for-ios/'),
        },
      ],
    },
    component: ForIos,
  },
  {
    path: '/for-pc/',
    name: 'en-for-pc',
    meta: {
      appname: site.appName,
      title: 'GB WhatsApp for PC: How to Run It on Windows',
      keywords: 'GB WhatsApp for PC, GB WhatsApp Windows, GB WhatsApp emulator',
      description: 'Learn how to run GB WhatsApp on PC with an Android emulator. See how to install the APK, set up your account, fix performance issues, and use WhatsApp on Windows.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/for-pc/'),
        },
      ],
    },
    component: ForPc,
  },
  {
    path: '/privacy-policy/',
    name: 'en-privacy',
    meta: {
      appname: site.appName,
      title: `Privacy Policy - ${site.siteName}`,
      keywords: `${site.siteName} privacy policy, gb whatsapp privacy, third-party apk information`,
      description: `Read the privacy policy for ${site.siteName}. This independent site explains how browsing data and email questions are handled.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/privacy-policy/'),
        },
      ],
    },
    component: () => import('@/views/privacy.vue'),
  },
  {
    path: '/disclaimer/',
    name: 'en-disclaimer',
    meta: {
      appname: site.appName,
      title: `Disclaimer - ${site.siteName}`,
      keywords: `${site.siteName} disclaimer, gb whatsapp risk, unofficial whatsapp mod`,
      description: `Read the disclaimer for ${site.siteName}. This independent site provides GB WhatsApp information only and is not affiliated with WhatsApp or the developer.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/disclaimer/'),
        },
      ],
    },
    component: () => import('@/views/disclaimer.vue'),
  },
  {
    path: '/about-us/',
    name: 'en-about',
    meta: {
      appname: site.appName,
      title: `About Us - ${site.siteName}`,
      keywords: `${site.siteName} about, gb whatsapp guide, apk download information`,
      description: `Learn about ${site.siteName}, an independent reference site for GB WhatsApp APK downloads and installation guides.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/about-us/'),
        },
      ],
    },
    component: () => import('@/views/about.vue'),
  },
  {
    path: '/contact-us/',
    name: 'en-contact',
    meta: {
      appname: site.appName,
      title: `Contact Us - ${site.siteName}`,
      keywords: `${site.siteName} contact, contact email, gb whatsapp download support`,
      description: `Contact ${site.siteName} by email for questions about GB WhatsApp APK information, downloads, or website content.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/contact-us/'),
        },
      ],
    },
    component: () => import('@/views/contact.vue'),
  },
  {
    path: '/blog/',
    alias: '/blog',
    name: 'en-blogs',
    meta: {
      appname: site.appName,
      title: 'GB WhatsApp Guides & Tips',
      keywords: 'gb whatsapp guides, gb whatsapp tips, gb whatsapp themes, gb whatsapp privacy',
      description:
        'Explore practical GB WhatsApp guides for themes, icon customization, call privacy, app settings, and common issues, with clear steps and useful troubleshooting tips.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/blog/'),
        },
      ],
    },
    component: () => import('@/views/blogs.vue'),
  },
  {
    path: '/change-gb-whatsapp-themes/',
    name: 'en-blog-themes',
    meta: {
      appname: site.appName,
      title: 'How to Change Themes in GB WhatsApp',
      keywords: 'change gb whatsapp themes, gb whatsapp themes, gb whatsapp customization',
      description:
        'Learn how to change themes in GB WhatsApp, customize chat colors and backgrounds, apply supported theme files, and restore the default look.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/change-gb-whatsapp-themes/'),
        },
      ],
    },
    component: () => import('@/views/blog-change-themes.vue'),
  },
  {
    path: '/change-call-privacy-settings-gb-whatsapp/',
    name: 'en-blog-call-privacy',
    meta: {
      appname: site.appName,
      title: 'How to Change Call Privacy Settings in GB WhatsApp',
      keywords: 'gb whatsapp call privacy, gb whatsapp call settings, gb whatsapp privacy',
      description:
        'Learn how to check GB WhatsApp call privacy settings, manage available call controls, troubleshoot missing options, and reduce unwanted interruptions.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/change-call-privacy-settings-gb-whatsapp/'),
        },
      ],
    },
    component: () => import('@/views/blog-call-privacy.vue'),
  },
]

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
  })
}
